<div class="flex-1 flex flex-col gap-4">
  @if (addressResult.length === 0) {
    <div class="flex flex-col gap-0">
      <span class="flex flex-col gap-0">
        {{
          "Non abbiamo trovato l’indirizzo che hai inserito." | transloco
        }}</span
      >
      <span class="flex flex-col gap-0">
        {{ "Vuoi confermare?" | transloco }}
      </span>
    </div>

    <div class="flex-1 flex flex-col gap-2">
      <div class="flex flex-col gap-0">
        <div>
          <span class="text-xs text-slate-400">
            {{ "Indirizzo" | transloco }}
          </span>
        </div>

        <div>
          <span class="text-xs text-slate-900">
            {{ updatedAddress.address }}
          </span>
        </div>
      </div>

      <div class="flex flex-row gap-4">
        <div class="flex flex-col gap-0">
          <div>
            <span class="text-xs text-slate-400">
              {{ "Comune" | transloco }}
            </span>
          </div>

          <div>
            <span class="text-xs text-slate-900">
              {{ updatedAddress.city }}
            </span>
          </div>
        </div>

        <div class="flex flex-col gap-0">
          <div>
            <span class="text-xs text-slate-400">
              {{ "CAP" | transloco }}
            </span>
          </div>

          <div>
            <span class="text-xs text-slate-900">
              {{ updatedAddress.zipCode }}
            </span>
          </div>
        </div>

        @if (isDistrictIncluded || updatedAddress.country !== "CH") {
          <div class="flex flex-col gap-0">
            <div>
              <span class="text-xs text-slate-400">
                {{ "Provincia" | transloco }}
              </span>
            </div>

            <div>
              <span class="text-xs text-slate-900">
                {{ updatedAddress.state }}
              </span>
            </div>
          </div>
        }

        <div class="flex flex-col gap-0">
          <div>
            <span class="text-xs text-slate-400">
              {{ "Nazione" | transloco }}
            </span>
          </div>

          <div>
            <span class="text-xs text-slate-900">
              {{ updatedAddress.country }}
            </span>
          </div>
        </div>
      </div>
    </div>
  }

  @if (addressResult.length > 0) {
    <div class="flex flex-col gap-0">
      <span class="text-sm text-slate-400">
        {{
          "Non abbiamo trovato l’indirizzo che hai inserito." | transloco
        }}</span
      >

      <span class="text-sm text-slate-400">
        {{
          "Vuoi mantenere quello inserito oppure quello suggerito?" | transloco
        }}
      </span>
    </div>

    <div class="flex-1 flex">
      <dx-list
        [dataSource]="addresses"
        [grouped]="true"
        [displayExpr]="'address'"
        [collapsibleGroups]="false"
        [selectionMode]="'single'"
        [showSelectionControls]="true"
        class="flex-1"
        (onSelectionChanged)="onSelectionChanged($event)"
      >
        <div *dxTemplate="let address of 'item'">
          <div class="flex flex-row items-center gap-2">
            <div class="text-wrap">
              <span
                class="p-1 rounded-md"
                [ngClass]="{
                  'text-red-500 font-bold': !isEqual(
                    updatedAddress.address!,
                    address.address!
                  )
                }"
              >
                {{ address.address }},</span
              >
              <span
                class="p-1 rounded-md"
                [ngClass]="{
                  'text-red-500 font-bold': !isEqual(
                    updatedAddress.city!,
                    address.city!
                  )
                }"
                >{{ address.city }}</span
              >
              <span
                class="p-1 rounded-md"
                [ngClass]="{
                  'text-red-500 font-bold': !isEqual(
                    updatedAddress.state!,
                    address.state!
                  )
                }"
                >{{ address.state! }},</span
              >
              <span
                class="p-1 rounded-md"
                [ngClass]="{
                  'text-red-500 font-bold': !isEqual(
                    updatedAddress.zipCode!,
                    address.zipCode!
                  )
                }"
                >{{ address.zipCode! }},</span
              >
              <span
                class="p-1 rounded-md"
                [ngClass]="{
                  'text-red-500 font-bold': !isEqual(
                    updatedAddress.country!,
                    address.country!
                  )
                }"
                >{{ address?.country }}</span
              >
            </div>
          </div>
        </div>
      </dx-list>
    </div>
  }
</div>
